// src/sanitize.ts
function isSecureProdDomainHost(hostname) {
  return hostname.toLowerCase().endsWith(".imobdesk.com.br");
}
function sanitizeInternalPath(raw, options) {
  if (typeof raw !== "string" || !raw.trim()) return void 0;
  const t = raw.trim();
  if (!t.startsWith("/") || t.startsWith("//")) return void 0;
  if (t.includes("://") || t.includes("\\")) return void 0;
  if (t.length > options.maxLength) return void 0;
  if (options.blockHandoffPath && t.startsWith("/auth/handoff")) return void 0;
  if (options.pathPattern && !options.pathPattern.test(t)) return void 0;
  return t;
}
function sanitizeHandoffNext(raw) {
  return sanitizeInternalPath(raw, {
    maxLength: 500,
    pathPattern: /^\/(workspace|dashboard)(\/|$)/
  });
}
function sanitizeSuporteHandoffNext(raw) {
  return sanitizeInternalPath(raw, {
    maxLength: 500,
    blockHandoffPath: true
  });
}
var ADMINDESK_CONTRATAR_PATH = /^\/contratar\/([a-zA-Z0-9_-]+)$/;
var ADMINDESK_ADMIN_PATH = /^\/admin(\/[a-zA-Z0-9_-]+)*$/;
var ADMINDESK_QUERY_KEYS = /* @__PURE__ */ new Set([
  "ciclo",
  "trial",
  "card",
  "cupom",
  "nomeImobiliaria",
  "successUrl",
  "cancelUrl"
]);
function admindeskSafeQueryValue(key, val) {
  if (val.length > 800) return false;
  if (key === "successUrl" || key === "cancelUrl") {
    try {
      const u = new URL(val);
      if (!/^https?:$/i.test(u.protocol)) return false;
      if (!/^[\w.-]+$/.test(u.hostname)) return false;
      return true;
    } catch {
      return false;
    }
  }
  if (key === "ciclo") return val === "mensal" || val === "anual";
  if (key === "trial") return /^\d{1,3}$/.test(val);
  if (key === "card") return val === "true" || val === "false";
  if (key === "cupom") return /^[a-zA-Z0-9_-]{1,40}$/.test(val);
  if (key === "nomeImobiliaria") {
    return val.length <= 255 && !/[<>]/.test(val);
  }
  return false;
}
function sanitizeAdmindeskHandoffNext(raw) {
  if (typeof raw !== "string" || !raw.trim()) return void 0;
  const t = raw.trim();
  if (!t.startsWith("/") || t.startsWith("//")) return void 0;
  if (t.includes("://") || t.includes("\\")) return void 0;
  if (t.length > 1200) return void 0;
  if (t.startsWith("/auth/handoff")) return void 0;
  const qIndex = t.indexOf("?");
  const pathOnly = qIndex === -1 ? t : t.slice(0, qIndex);
  if (ADMINDESK_ADMIN_PATH.test(pathOnly)) {
    if (qIndex !== -1) return void 0;
    return pathOnly;
  }
  if (!ADMINDESK_CONTRATAR_PATH.test(pathOnly)) return void 0;
  if (qIndex === -1) return pathOnly;
  const incoming = new URLSearchParams(t.slice(qIndex + 1));
  const out = new URLSearchParams();
  incoming.forEach((v, key) => {
    if (!ADMINDESK_QUERY_KEYS.has(key)) return;
    if (admindeskSafeQueryValue(key, v)) out.append(key, v);
  });
  const qs = out.toString();
  return qs ? `${pathOnly}?${qs}` : pathOnly;
}
function getSafeAdmindeskPostLoginPath(path) {
  if (typeof path !== "string" || !path.trim()) return "/admin";
  return sanitizeAdmindeskHandoffNext(path.trim()) ?? "/admin";
}

// src/build-handoff-url.ts
function stripTrailingSlash(value) {
  return value.replace(/\/$/, "");
}
function buildHandoffUrl(options) {
  const {
    baseUrl,
    accessToken,
    next,
    sanitizeNext,
    defaultNext,
    accessTokenMode = "prod-cookie"
  } = options;
  const url = new URL(`${stripTrailingSlash(baseUrl)}/auth/handoff`);
  const shouldIncludeToken = Boolean(accessToken) && (accessTokenMode === "always" || accessTokenMode === "prod-cookie" && !isSecureProdDomainHost(url.hostname));
  if (shouldIncludeToken && accessToken) {
    url.searchParams.set("access_token", accessToken);
  }
  const sanitizedNext = sanitizeNext ? sanitizeNext(next) : void 0;
  const nextPath = sanitizedNext ?? defaultNext;
  if (nextPath) {
    url.searchParams.set("next", nextPath);
  }
  return url.toString();
}

export { buildHandoffUrl, getSafeAdmindeskPostLoginPath, isSecureProdDomainHost, sanitizeAdmindeskHandoffNext, sanitizeHandoffNext, sanitizeSuporteHandoffNext };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map